<template>
  <v-btn rounded v-if="isRecalculating" :min-width="60">
    <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>
  </v-btn>
  <v-btn rounded v-else>{{score}}</v-btn>
</template>

<script>
export default {
  name: "ModelPerformanceChip",
  props: {
    model: {required: true},
    threshold: {required: true}
  },
  computed: {
    isRecalculating() {
      return this.$store.getters['recalculation/is_model_recalculating'](this.model.id);
    },
    score () {
      let performance = this.model.performance;
      if(!performance) {
        return '-'
      }
      else {
        performance = JSON.parse(performance);
        // Convert threshold to number to ensure correct key lookup
        const threshold = Number(this.threshold);
        // Performance JSON uses correct_0 … correct_95 (step 5); slider allows 100.
        const scoreKey = 'correct_' + Math.min(95, threshold);
        const scoreValue = performance[scoreKey];
        // Return '-' if score value is not available for this threshold
        if (scoreValue === undefined || scoreValue === null) {
          return '-';
        }
        return Math.round(scoreValue * 100) + '%';
      }
    }
  },
  mounted() {
    this.$store.dispatch('recalculation/ensure_subscribed');
  }
}
</script>

<style scoped>

</style>
